import { resources } from "@constants/hardcoded-strings";
import {
    POLICY_COMPONENT_DETAILS_URL
} from "@constants/routes";
import { POLICY_COMPONENT_ID_PATTERN } from "@constants/url-parameter-patterns";
import { CellDropdownItem } from "@idw-types/common";
import { navigateToUtil } from "@utils/navigation-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TableCellWithDropdown } from "../../common/table-cell-with-dropdown/table-cell-with-dropdown";
import { PolicyComponentsTableDataRow } from "@containers/policy-components/policy-components-table-container/policy-components-table-container";

type PolicyComponentTableCellProps = {
    policyComponentsTableDataRow: PolicyComponentsTableDataRow
};

export const PolicyComponentTableCell = (props: PolicyComponentTableCellProps) => {
    const {
        policyComponentsTableDataRow
    } = props;

    const navigate = useNavigate();
    const routerLocation = useLocation();

    const handleOpenComponentDetails = () => {
        const url = injectCustomIdParameter(
            POLICY_COMPONENT_DETAILS_URL,
            policyComponentsTableDataRow.id,
            POLICY_COMPONENT_ID_PATTERN
        );
        navigateToUtil(url, navigate, routerLocation.pathname);
    }

    const policyComponentDropdownItems = useMemo(() => {
        const items: Array<CellDropdownItem> = [];
        const prefix = "policy-component-list";

        if (policyComponentsTableDataRow.permissions.canView) {
            items.push({
                idSuffix: `${prefix}-open`,
                title: resources.tables.deployedPolicyComponents.dropdownItems.open.label,
                text: resources.tables.deployedPolicyComponents.dropdownItems.open.label,
                onClick: handleOpenComponentDetails
            });
        }
        return items;
    }, []);






    return (
        <TableCellWithDropdown
            value={policyComponentsTableDataRow.name}
            dropdownText={""}
            items={policyComponentDropdownItems}
            uniqueId={policyComponentsTableDataRow.id}
        />
    );
};